import { render, staticRenderFns } from "./PageImage.vue?vue&type=template&id=683e52cb&"
import script from "./PageImage.vue?vue&type=script&lang=js&"
export * from "./PageImage.vue?vue&type=script&lang=js&"
import style0 from "./PageImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports